module.exports = __webpack_public_path__ + "static/media/close.ba28c622.svg";